<script>

	import { onMount, createEventDispatcher } from 'svelte';
	import { fade, fly } from "svelte/transition";
	
	import {	session, event } from '../lib/stores.js';

	const dispatch = createEventDispatcher();

	export let playback;
	export let token = null;
	export let autoplay = true;
	export let loop = false;
	export let startAt = 0;

	let player;
	let streamType = 'on-demand';
	let muxPlayback = token ? playback + '?token=' + token : playback;

	function play() {
		console.log({startAt});
		if (startAt) {
			player.media.currentTime = startAt;
		}
		dispatch('play');
	}

</script>

<style>
	div.player,
	media-controller,
	mux-video {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
</style>

<div class="player" transition:fade|local={{duration: 400}}>
	<media-controller autohide="2" bind:this={player}>
		<mux-video
			slot="media"
			preload="auto"
			stream-type={streamType}
			playback-id="{muxPlayback}"
			{autoplay}
			{loop}
			on:play={play}
			on:ended
			prefer-mse
			playsinline
		></mux-video>
	</media-controller>
</div>

